// START Open Requre.JS wrapper
define(["jquery",
		"wcs.context",
        "wcs.product-price-util", "wcs.product-price-ajax", 'wcs.utils'],
		function($, ctx, priceContainerUtil, pricePromise, utils){

	var DEBUG = false;

	var that = {};

	that.init = function($productForm) {
		if ( DEBUG )  console.log("Initializing WCS Product Price Service");

		// make this context available to inner functions of init()
		var self = this;

		if( !$productForm){
            self.$productForm = $('.product-form-js');
        }
		else {
            self.$productForm = $productForm;
        }

		that.$productForm 				= self.$productForm;
		that._isColorBundle 			= null;
		that._isProductBundle 			= null;
		that._bundlePartNumber			= null;
		that._productId 				= [];
		that._attrId 					= [];
		that._itemPricingJSONCache 		= window.itemPrices || {};
		that._isBuyable 				= [];
		that._possibleProducts 			= [];
		that._isListenersSet 			= false;
		that._isInitialized 			= false;
		that._lastClickedElement 		= null;
		that._fetchQueue 				= [];
		that._fetchPointer 				= 0;
		that._retryCount 				= [];
		that._firstLoad 				= WCS_CONFIG.get('PDP::ignoreSelectionOnFirstLoad');
		that.pdp30DaysListPriceEnabled  = WCS_CONFIG.get('PDP::pdp30DaysListPriceEnabled') || false;
		that.pdpEnableRefreshPriceOnSizeChanged = WCS_CONFIG.get('PDP::pdpEnableRefreshPriceOnSizeChanged') || false;
		that.DEFAULT_RETRY_COUNT 		= 5;

        // product pricing levels:
        that.productCandidates 			= [];
        that.price 						= null;
        that.listPrice 					= null;
        that.lowPrice 					= null;
        that.highPrice 					= null;
        that.lowListPrice 				= null;
        that.highListPrice 				= null;
        that.lowPriceNumeric 			= 0;
        that.highPriceNumeric 			= 0;
        that.lowListPriceNumeric 		= 0;
        that.highListPriceNumeric 		= 0;
        that.lowDiscountPercentage 		= 0;
        that.highDiscountPercentage 	= 0;

        that.metadata = this.$productForm.data('product-pricing-options');

        that.productFormIndex = $('.product-form-js').index(this.$productForm);


		self.config = $.extend({}, self.defaults, self.options, self.metadata);


		self._isColorBundle = self.$productForm.find(".selection-js [data-product-id]").length || $('.context-trigger-js').length !== 0;
		self._bundlePartNumber = self.$productForm.data('bundle-part-number') || null;
		self._isProductBundle = self._multipleProductFormsPresent = $('.product-form-js').length > 1;

		return self;
	};

	that.parseProductFormAttributes = function (productFormIdentifier) {

		if ( DEBUG ) console.log('parseProductFormAttributes');

		if (productFormIdentifier) {
			if (this.currentProductFormIdentiers !== productFormIdentifier) {
				this.currentProductFormIdentiers = productFormIdentifier;
				this.$prevProductForm = this.$productForm;
				this.$productForm = $(productFormIdentifier);
			} else {
				this.$productForm = $(productFormIdentifier);
			}
		} else {
			if (this.$prevProductForm) {
				this.$productForm = this.$prevProductForm;
				this.$prevProductForm =  '';
				this.currentProductFormIdentiers = '';
			}
		}

		var self = this;

		self.$productForm.each(function(index) {
			var $this = $(this),
				$productPrice = that._getProductPriceContainer(index);

			that._productId[index] = $this.find('input[name=catEntryId]').val();
			that._attrId[index] = $this.find('input[name=attrName]').val();
			that._possibleProducts[index] = [];
			that._isBuyable[index] = true;
			that._retryCount[index] = self.DEFAULT_RETRY_COUNT;

			if($productPrice.length) {
				that._handleItemPricing(index, that._productId[index]);
			}

		});

		return this;
	};

	that._getProductPriceContainer = function(index){

		if ( DEBUG ) console.log('_getProductPriceContainer');

		var self = this;
		if(self._isProductBundle) {
			if (this.$prevProductForm) {
				return $(".stl-widget .price-container-js").eq(index).find("> .product-price-js"); // add new unique class
			}
			return $(".price-container-js").eq(index).find("> .product-price-js");
		} else {
			if (this.$prevProductForm) { 
				return $(".stl-widget #product-info .product-price-js, .price-container-js .product-price-js").eq(index);
			}
			return $("#product-info .product-price-js, .price-container-js .product-price-js").eq(index);
		}
	};

	that._getProductIdFromURLParameter = function () {
		return ctx.getParameterByName('productId');
	};

	that._getPricingByProductID = function (index, productId) {
		if( !that._initialPriceFetched ){ // This should be executed only on the first load, and not on color click. There is no way to change productId, so subsequent calls cannot be parameteraized with different productId's
			pricePromise.done(function(data) { //In case of PDP, there is an early ajax call, so the promise would be resolved and ready - containing the prices.
				that._handleSuccessDataReturn(index, productId, data);
				that._initialPriceFetched = true;
			}).fail(function(error) {
				that._makeAnAjax(index, productId);
			});
		}
		else {
			that._makeAnAjax(index, productId);
		}
	};

	that._makeAnAjax = function(index, productId){
		var jsonPricingURL = that.$productForm.data('priceUrl');

		if((typeof jsonPricingURL !== "undefined") && !!productId) {
			var ajaxPromise = $.ajax({
				url: ctx.getURLWithContextRoot(jsonPricingURL),
				data: {
					storeId: ctx.getStoreId(),
					langId: ctx.getLangId(),
					catalogId: ctx.getCatalogId(),
					productId: productId
				}
			});
			that._handlePromise(ajaxPromise, index, productId);
		}
	};

	that._handlePromise = function(ajaxPromise, index, productId){
		ajaxPromise.done(function(data){
			that._handleSuccessDataReturn(index, productId, data);
		}).fail(function(){
			that._handleErrorReturn(index, productId);
		});
	};

	that._handleSuccessDataReturn = function(index, productId, data) {

			if ( DEBUG ) console.log('_handleSuccessDataReturn');

			var self = this;

			if(data === '') // Try again if data is empty
				self._handleErrorReturn(index, productId);
			self._itemPricingJSONCache[productId] = data;
			self._handleItemPricing(index, productId);
		};

	that._handleErrorReturn = function(index, productId){

			if ( DEBUG ) console.log('_handleErrorReturn');

			var self = this;

			// Try getting the price again
			if(self._retryCount[index] === 0) {
				return true;
			} else {
				self._retryCount[index]--;
				self._getPricingByProductID(index, productId);
			}
		};

	that._handleItemPricing = function(index, productId){

			if ( DEBUG ) console.log('_handleItemPricing');

			var self = this,
				data;

			if(!self._itemPricingJSONCache.hasOwnProperty(productId) || ( self.pdp30DaysListPriceEnabled && typeof self._itemPricingJSONCache[productId].pricing.default != 'undefined' && typeof self._itemPricingJSONCache[productId].pricing.default.low30DaysListPriceNumeric == 'undefined') ) {
				self._getPricingByProductID(index, productId);
				return;
			} else {
				data = self._itemPricingJSONCache[productId];
				that._initialPriceFetched = true;
			}

			self._isInitialized = true;

			// update _isBuyable flag
			if(typeof data.buyable !== "undefined") {
				self._isBuyable[index] = data.buyable;
			}

			if(self._isBuyable[index] === true) {
				// show default pricing if buyable flag is true
				self._resetPrice(index);
				// that._refreshProductPrice(index);

			} else {
				// show no pricing html if buyable flag is false
				self._showProductPrice(index, null);
			}

			if ( self._getProductIdFromURLParameter() ){
				self._resetPrice(index);
				// that._refreshProductPrice(index);
			}
		};

    that._getNewAttributeSelections = function(index){

        if ( DEBUG ) console.log('_getNewAttributeSelections');

        var self = that;
        self.$productForm.eq(index).find(".attr-box.selected:visible").each(function(){
            var attrValue = $(this).data("attribute-value"),
                attrId = $(this).closest(".selection-js").data("attribute-id");

            if( WCS_CONFIG.get('PDP::pdpPriceUseColorCodeEnabled')) {
                if ($(this).data("color-identifier")) {
                  attrValue = $(this).data("color-identifier");
                } else {
                  // Make sure we set variable attrValue to null when not a color
                  attrValue = undefined;
                }
            }

            // for color bundle attributes, attrId is stored elsewhere
            if(typeof attrId === "undefined") {
                attrId = self._attrId[index];
            }

            that.handleAttrInputChange(index, attrId, attrValue, -1);
        });

        self.$productForm.eq(index).find(".attr-input-js option:selected").each(function(){
            var attrValue 	= $(this).data("attribute-value"),
                attrId 		= $(this).closest(".selection-js").data("attribute-id");

            // for color bundle attributes, attrId is stored elsewhere
            if(typeof attrId === "undefined") {
                attrId = self._attrId[index];
            }

            self.handleAttrInputChange(index, attrId, attrValue, -1);
        });
    };

    // calculate pricing based on current attribute selections
    that._resetPrice = function(index) {

        if ( DEBUG ) console.log('_resetPrice');

        var self = that;
        self._possibleProducts[index] = [];
        if(self._firstLoad === true) {
            self._firstLoad = false;
        }else{
            self._getNewAttributeSelections(index);
        }
        self._refreshProductPrice(index);
    };

	that.loadPriceValues = function(priceContainer, pricingObj){

		if ( DEBUG ) console.log('loadPriceValues');
		priceContainer.parents('#product-info').removeClass('history-lowest-price-show');
		
		var low30DaysListPrice = null,
			high30DaysListPrice = null,
			lowestPriceNumeric = null,
			highestPriceNumeric = null,
			low30DaysPrinceInfo = {
				has30DaysListPrice : false,
				is30DaysPriceGreaterOffer : false
			};

        if ( that.pdp30DaysListPriceEnabled && pricingObj!=null ) {
			if (typeof pricingObj.productLow30DaysListPrice!= 'undefined' && pricingObj.productLow30DaysListPrice!=null && pricingObj.productLow30DaysListPrice!="" ) {
				if ( pricingObj.highListPriceNumeric > pricingObj.productLow30DaysListPriceNumeric ) {
					low30DaysListPrice = pricingObj.productLow30DaysListPrice,
					high30DaysListPrice = pricingObj.productHigh30DaysListPrice,
					low30DaysPrinceInfo.has30DaysListPrice = true;
					lowestPriceNumeric = pricingObj.productLow30DaysListPriceNumeric;
					highestPriceNumeric = pricingObj.productHigh30DaysListPriceNumeric;
					if ( pricingObj.productLow30DaysListPriceNumeric > pricingObj.lowPriceNumeric ) {
						low30DaysPrinceInfo.is30DaysPriceGreaterOffer = true;
					} else {
						low30DaysPrinceInfo.is30DaysPriceGreaterOffer = false;
					}	
				}
			} else if ( typeof pricingObj.low30DaysListPriceNumeric!= 'undefined' && pricingObj.low30DaysListPriceNumeric!=null && pricingObj.low30DaysListPriceNumeric!="") {
				if ( pricingObj.lowPriceNumeric > pricingObj.low30DaysListPriceNumeric ) {
					low30DaysListPrice = pricingObj.low30DaysListPrice,
					low30DaysPrinceInfo.has30DaysListPrice = true;
					lowestPriceNumeric = pricingObj.low30DaysListPriceNumeric;
					if ( pricingObj.low30DaysListPriceNumeric > pricingObj.lowPriceNumeric ) {
						low30DaysPrinceInfo.is30DaysPriceGreaterOffer = true;
					} else {
						low30DaysPrinceInfo.is30DaysPriceGreaterOffer = false;
					}
				}
			} 
        }

		var util = new priceContainerUtil(priceContainer),
			temp,
			tempPrice,
			priceNumeric = [],
			listPriceNumeric,
			noSaleOnHighListPrice = false,
			discountPercentageNumeric = [];
		
		if (that.pdp30DaysListPriceEnabled) {
			util.hide30DaysHistoryPrice();
		}
		if (that.pdpEnableRefreshPriceOnSizeChanged) {
			$('.product-price-js').removeClass('range-price');
			$('.discount-price-js').removeClass('range-price');
		}
		if(typeof pricingObj === 'undefined' || pricingObj === null){

			util.updatePriceHTML(setToZero = true, undefined);
			util.hideAllPrices();
		} else {
			var price,
				listPrice,
				dataAmountPrice;
			if (pricingObj.lowDiscountPercentage) {
				discountPercentageNumeric.push(pricingObj.lowDiscountPercentage);
			}
			if (pricingObj.highDiscountPercentage && (discountPercentageNumeric.length === 0 || pricingObj.highDiscountPercentage < pricingObj.lowDiscountPercentage)) {
				discountPercentageNumeric.push(pricingObj.highDiscountPercentage);
			}
			if(pricingObj.lowPriceNumeric == pricingObj.highPriceNumeric) {
				price = pricingObj.lowPrice;
				priceNumeric[0] = pricingObj.lowPriceNumeric;

			} else {

				// show highPrice as default text color if equal to highList price
				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled')  && ( pricingObj.highPriceNumeric === pricingObj.highListPriceNumeric ) ) {
					if (that.pdpEnableRefreshPriceOnSizeChanged) {
						$('.product-price-js').addClass('range-price');
						$('.discount-price-js').addClass('range-price');
						price = $('.current-price-js').data('text-from') +" "+pricingObj.lowPrice;
					} else {
						price = pricingObj.lowPrice + " <bdi>- " + pricingObj.highPrice + "</bdi>";
					}
					noSaleOnHighListPrice = true;

					if (that.catEntryId && WCS_CONFIG.get('grid::productShowSkuPrice') === true) {
						try {
							var priceObj = that._itemPricingJSONCache[that._productId[0]];
							var skuPrice = priceObj.pricing.sku[that.catEntryId].listPrice;
							price = skuPrice;
						}catch (err){
							console.error(err);
						}
					}

				} else {
					if (that.pdpEnableRefreshPriceOnSizeChanged) {
						$('.product-price-js').addClass('range-price');
						$('.discount-price-js').addClass('range-price');
						price = $('.current-price-js').data('text-from') +" "+pricingObj.lowPrice;
					} else {
						price = pricingObj.lowPrice + " - " + pricingObj.highPrice;
					}
				}

				priceNumeric[0] = pricingObj.lowPriceNumeric;

				// don't create item if high price equals high list price as there's no need to calculate a discount
				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled') && (pricingObj.highPriceNumeric !== pricingObj.highListPriceNumeric) ){
					priceNumeric[1] = pricingObj.highPriceNumeric;
				}
			}
			that.latestPrice = price;

			if(pricingObj.lowListPriceNumeric == pricingObj.highListPriceNumeric) {
				listPrice = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPrice : pricingObj.lowPrice);
				listPriceNumeric = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPriceNumeric : pricingObj.lowPriceNumeric);

			} else {
				var lowListPrice = (pricingObj.lowPriceNumeric <= pricingObj.lowListPriceNumeric ? pricingObj.lowListPrice : pricingObj.lowPrice);
				var highListPrice = (pricingObj.highPriceNumeric <= pricingObj.highListPriceNumeric ? pricingObj.highListPrice : pricingObj.highPrice);
				if (lowListPrice != highListPrice){
					listPrice = lowListPrice + " - " + highListPrice;
				}
				else{
					listPrice = lowListPrice;
				}

				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled') ){

					// set as array to store range values
					listPriceNumeric = [];

					// only add highPrice if it's less than highListPrice
					if( pricingObj.highPriceNumeric < pricingObj.highListPriceNumeric ){
						listPriceNumeric[0] =  pricingObj.lowListPriceNumeric;
						listPriceNumeric[1] =  pricingObj.highListPriceNumeric;
					}
					else{
						listPriceNumeric[0] =  pricingObj.lowListPriceNumeric;
					}
				}

			}

			dataAmountPrice = pricingObj.lowPriceNumeric;
			util.setDataAmount(dataAmountPrice);
			if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true || ( that.pdp30DaysListPriceEnabled && low30DaysPrinceInfo.has30DaysListPrice ) ) {
				if(price != listPrice) {
					temp = 0;
					tempPrice = 0;
					var	listPriceNum,
						tempPriceNum = 0,
						hasPriceDelimiters = WCS_CONFIG && WCS_CONFIG.global && WCS_CONFIG.global.priceDelimiters,
						thousandsRegex;

					if (hasPriceDelimiters) {
						var escapedDelimiter = "\\" + WCS_CONFIG.global.priceDelimiters.thousands;
						thousandsRegex = new RegExp(escapedDelimiter, 'g');
					}
					if(price.indexOf("-") > -1){
						temp = price.split("-");
						tempPrice = temp[0].trim();
						if (hasPriceDelimiters) {
							tempPrice = tempPrice.replace(thousandsRegex, '');
						}
						tempPriceNum = tempPrice.match(/\d+([\/.]\d+)?/g);
						tempPriceNum = parseFloat(tempPriceNum[0]);
					}
					if (hasPriceDelimiters) {
						listPriceNum = listPrice.replace(thousandsRegex, '').match(/\d+([\/.]\d+)?/g);
					} else {
						listPriceNum = listPrice.match(/\d+([\/.]\d+)?/g);
					}
					listPriceNum = parseFloat(listPriceNum[0]);
					if(tempPriceNum >= listPriceNum){
						util.updatePriceHTML(setToZero = true, price);
					}else{
						if (low30DaysPrinceInfo.is30DaysPriceGreaterOffer && priceNumeric.length > 1) {
							var rangePrice30daysString = null;
								rangePrice30daysNumeric = null;
							if (pricingObj.high30DaysListPriceNumeric != pricingObj.low30DaysListPriceNumeric) {
								rangePrice30daysString = pricingObj.low30DaysListPriceNumeric + " - " +pricingObj.high30DaysListPrice;
								rangePrice30daysNumeric = [pricingObj.low30DaysListPriceNumeric,pricingObj.high30DaysListPriceNumeric];
							} else if (pricingObj.productLow30DaysListPrice != pricingObj.productHigh30DaysListPrice) {
								rangePrice30daysString = pricingObj.productLow30DaysListPrice + " - " +pricingObj.productHigh30DaysListPrice;
								rangePrice30daysNumeric = [pricingObj.productLow30DaysListPrice,pricingObj.productHigh30DaysListPrice]
							} else {
								rangePrice30daysString = low30DaysListPrice;
								rangePrice30daysNumeric = [pricingObj.low30DaysListPriceNumeric,pricingObj.high30DaysListPriceNumeric];
							}
							util.showSalePrice(rangePrice30daysString, price, priceNumeric, rangePrice30daysNumeric, noSaleOnHighListPrice, discountPercentageNumeric, low30DaysPrinceInfo);
						} else {
							var isPDP = (priceContainer.parents('.product-detail').length > 0);
							if ( !isPDP && low30DaysListPrice != null && pricingObj.lowPriceNumeric == pricingObj.highPriceNumeric ) {
								listPrice = low30DaysListPrice,
								listPriceNumeric = [lowestPriceNumeric];
							}
							util.showSalePrice(listPrice, price, priceNumeric, listPriceNumeric, noSaleOnHighListPrice, discountPercentageNumeric, low30DaysPrinceInfo);
						}
					}
					if (low30DaysPrinceInfo.is30DaysPriceGreaterOffer) {
						var lowestPriceNumeric = [lowestPriceNumeric];
						util.show30DaysHistoryPrice(lowestPriceNumeric, priceNumeric, low30DaysListPrice);
					}
				} else if(price == listPrice) {
					util.updatePriceHTML(setToZero = false, price);
				} else {
					util.updatePriceHTML(setToZero = true, undefined);
				}

			}
			else{
				if(price != listPrice) {
					temp = 0;
					tempPrice = 0;
					if(price.indexOf("-") > -1){
						temp = price.split("-");
						tempPrice = temp[0].trim();
					}
					if(tempPrice >= listPrice){
						util.updatePriceHTML(setToZero = true, price);
					}else{
						util.showSalePrice(listPrice, price);
					}
				} else if(price == listPrice) {
					util.updatePriceHTML(setToZero = false, price);
				} else {
					util.updatePriceHTML(setToZero = true, undefined);

				}
			}
		}
	};

    that._showProductPrice = function(index, pricingObj){

                if ( DEBUG ) console.log('_showProductPrice');

                var self = that,
                    productPriceHTML = "",
                    $productPrice = self._getProductPriceContainer(index);

                self.loadPriceValues($productPrice, pricingObj);

                if(WCS_CONFIG.get('PDP::showPriceAboveAddToCart') === true) {
                    var $mobilePrice = $(".product-actions-product-price-container .product-price-js").eq(0);
                    self.loadPriceValues($mobilePrice, pricingObj);
                }
            };

    that._refreshProductPrice = function (index) {

        if (DEBUG) console.log('_refreshProductPrice +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');

        var self = that,
            _productId = self._productId;
        // update pricing text based on attribute selections
        if (self._possibleProducts[index].length === 0 ) {
            if (typeof self._itemPricingJSONCache[self._productId[index]] !== "undefined") {
                if (DEBUG) console.log("Cached price data exists", self._itemPricingJSONCache, self._productId, index);
				if ( self.pdp30DaysListPriceEnabled ) {
					self.getNewProductPricingData(index);
				} else {
					self._showProductPrice(index, self._itemPricingJSONCache[_productId[index]].pricing["default"]);
				}
            } else if (DEBUG) {
                console.warn("Missing cached price data when selecting size context", self._itemPricingJSONCache, self._productId, index);
            }
        } else if (!self._itemPricingJSONCache[_productId[index]].pricing) {
            self._showProductPrice(index, null);
        } else {
            self.getNewProductPricingData(index);
        }
    };

    that.buildProductPriceJSONForRenderingPrice = function(index){

                if ( DEBUG ) console.log('buildProductPriceJSONForRenderingPrice');

                var self = that,
                    priceJSON = {},
                    _productId = self._productId,
                    firstLoop = true;
                // loop through all qualified products for final price range
				var productLow30DaysListPriceNumeric = null,
					productLow30DaysListPricePercentage = null,
					productLow30DaysListPrice = null,
					productHigh30DaysListPriceNumeric = null,
					productHigh30DaysListPricePercentage = null,
					productHigh30DaysListPrice = null;
                for(var j in self.productCandidates) {
                    var productId = self.productCandidates[j],
                        product = self._itemPricingJSONCache[_productId[index]].pricing.sku[productId],
						productDefault = self._itemPricingJSONCache[_productId[index]].pricing["default"],
                        productPrice = product.price,
                        productPriceNumeric = product.priceNumeric,
                        productListPrice = product.listPrice,
                        productListPriceNumeric = product.listPriceNumeric,
                        productDiscountPercentage = utils.calculateDiscount(productPriceNumeric, productListPriceNumeric),
						high30DaysListPrice = null,
						high30DaysListPriceNumeric = null,
						low30DaysListPrice = null,
						low30DaysListPriceNumeric = null;

					if ( that.pdp30DaysListPriceEnabled ) {
						if (typeof product.last30DaysListPriceNumeric!='undefined' && product.last30DaysListPriceNumeric!=null) {
							if (productHigh30DaysListPriceNumeric == null && productLow30DaysListPriceNumeric == null) {
							productLow30DaysListPriceNumeric = product.last30DaysListPriceNumeric,
							productLow30DaysListPrice = product.last30DaysListPrice;
							productLow30DaysListPricePercentage = utils.calculateDiscount(productLow30DaysListPriceNumeric, productListPriceNumeric);
							productHigh30DaysListPriceNumeric = productLow30DaysListPriceNumeric;
							productHigh30DaysListPrice = productLow30DaysListPrice;
							productHigh30DaysListPricePercentage = productLow30DaysListPricePercentage;
							} else if ( product.last30DaysListPriceNumeric < productLow30DaysListPriceNumeric) {
								productLow30DaysListPriceNumeric = product.last30DaysListPriceNumeric,
								productLow30DaysListPrice = product.last30DaysListPrice;
								productLow30DaysListPricePercentage = utils.calculateDiscount(productLow30DaysListPriceNumeric, productListPriceNumeric);
							} else if ( product.last30DaysListPriceNumeric > productHigh30DaysListPriceNumeric) {
								productHigh30DaysListPriceNumeric = product.last30DaysListPriceNumeric,
								productHigh30DaysListPrice = product.last30DaysListPrice;
								productHigh30DaysListPricePercentage = utils.calculateDiscount(productLow30DaysListPriceNumeric, productListPriceNumeric);
							}
						}
					}

                    if(firstLoop ) {
                        firstLoop = false;
                        self.lowPrice = productPrice;
                        self.highPrice = productPrice;
                        self.lowListPrice = productListPrice;
                        self.highListPrice = productListPrice;
                        self.lowPriceNumeric = productPriceNumeric;
                        self.highPriceNumeric = productPriceNumeric;
                        self.lowListPriceNumeric = productListPriceNumeric;
                        self.highListPriceNumeric = productListPriceNumeric;
						self.lowDiscountPercentage = productDiscountPercentage;
						self.highDiscountPercentage = productDiscountPercentage;
                    }
                    else {
                        if(productPriceNumeric < self.lowPriceNumeric) {
                            self.lowPriceNumeric = productPriceNumeric;
                            self.lowPrice = productPrice;
                        }
                        if(productPriceNumeric > self.highPriceNumeric) {
                            self.highPriceNumeric = productPriceNumeric;
                            self.highPrice = productPrice;
                        }
                        if(productListPriceNumeric < self.lowListPriceNumeric) {
                            self.lowListPriceNumeric = productListPriceNumeric;
                            self.lowListPrice = productListPrice;
                        }
                        if(productListPriceNumeric > self.highListPriceNumeric) {
                            self.highListPriceNumeric = productListPriceNumeric;
                            self.highListPrice = productListPrice;
                        }
						if (productDiscountPercentage > self.lowDiscountPercentage) {
							self.lowDiscountPercentage = productDiscountPercentage;
						}
						if (productDiscountPercentage < self.highDiscountPercentage) {
							self.highDiscountPercentage = productDiscountPercentage;
						}
                    }
					self.productLow30DaysListPriceNumeric = productLow30DaysListPriceNumeric;
					self.productLow30DaysListPricePercentage = productLow30DaysListPricePercentage;
					self.productLow30DaysListPrice = productLow30DaysListPrice;
					self.productHigh30DaysListPriceNumeric = productHigh30DaysListPriceNumeric;
					self.productHigh30DaysListPricePercentage = productHigh30DaysListPricePercentage;
					self.productHigh30DaysListPrice = productHigh30DaysListPrice;
					self.high30DaysListPrice = high30DaysListPrice,
					self.high30DaysListPriceNumeric = high30DaysListPriceNumeric,
					self.low30DaysListPrice = low30DaysListPrice,
					self.low30DaysListPriceNumeric = low30DaysListPriceNumeric;
                }

                priceJSON = {
                    "lowPrice": self.lowPrice,
                    "lowPriceNumeric": self.lowPriceNumeric,
                    "highPrice": self.highPrice,
                    "highPriceNumeric": self.highPriceNumeric,
                    "lowListPrice": self.lowListPrice,
                    "lowListPriceNumeric": self.lowListPriceNumeric,
                    "highListPrice": self.highListPrice,
                    "highListPriceNumeric": self.highListPriceNumeric,
                    "lowDiscountPercentage": self.lowDiscountPercentage,
                    "highDiscountPercentage": self.highDiscountPercentage,
					"productLow30DaysListPrice": self.productLow30DaysListPrice,
					"productLow30DaysListPriceNumeric": self.productLow30DaysListPriceNumeric,
					"productLow30DaysListPricePercentage": self.productLow30DaysListPricePercentage,
					"productHigh30DaysListPrice": self.productHigh30DaysListPrice,
					"productHigh30DaysListPriceNumeric": self.productHigh30DaysListPriceNumeric,
					"productHigh30DaysListPricePercentage": self.productHigh30DaysListPricePercentage,
					"high30DaysListPrice": self.high30DaysListPrice,
					"high30DaysListPriceNumeric": self.high30DaysListPriceNumeric,
					"low30DaysListPrice": self.low30DaysListPrice,
					"low30DaysListPriceNumeric": self.low30DaysListPriceNumeric
                };

                return priceJSON;
            };

    that.getNewProductPricingData = function(index){

        if ( DEBUG ) console.log('getNewProductPricingData');

        var self = that;
        // set output product array to be the possible products from the first selected attribute
        if (self._possibleProducts[index].length > 0 ) {
			self.productCandidates = self._possibleProducts[index][0].sku;	
		}

        // loop through all selected attributes, find intersections of products
        for(var i in self._possibleProducts[index]) {
            self.productCandidates = self.arrayIntersection(self.productCandidates, self._possibleProducts[index][i].sku);
        }
        if(self.productCandidates.length > 0) {
            self._showProductPrice(index, that.buildProductPriceJSONForRenderingPrice( index ) );
        } else {
            self._showProductPrice(index, null);
        }
    };

    that.arrayIntersection = function (arrayA, arrayB) {

        if (DEBUG) console.log('arrayIntersection');

        var tmpArray = [];
        for (var i in arrayA) {
            if (arrayB.indexOf(arrayA[i]) > -1) {
                tmpArray.push(arrayA[i]);
            }
        }
        return tmpArray;
    };

            //REFACTOR ME
    that.handleAttrInputChange = function(index, attrId, attrValue, attrIndex){

        if ( DEBUG ) console.log('handleAttrInputChange');

        var self = that,
            _productId 	= self._productId;

        if(typeof attrValue === "undefined" && attrIndex > -1) {
            //user sets the attribute value to empty, needs to reset possible products on that attribute
            if(attrIndex === 0 && self._possibleProducts[index].length === 1) {
                self._possibleProducts[index] = [];
            }
            else if(attrIndex === 0) {
                self._possibleProducts[index][attrIndex].sku = self._possibleProducts[index][1].sku;
            } else {
                self._possibleProducts[index][attrIndex].sku = self._possibleProducts[index][0].sku;
            }
        } else if(typeof attrValue !== "undefined") {
            var tmpSku = [];
            if(typeof self._itemPricingJSONCache[self._productId[index]] !== "undefined"){
                if(typeof self._itemPricingJSONCache[self._productId[index]].pricing[attrId] === "undefined") {
                    // selected attribute is not in the returned pricing json
                    if(typeof self._itemPricingJSONCache[self._productId[index]].pricing.sku !== 'undefined'){
                        $.each(self._itemPricingJSONCache[self._productId[index]].pricing.sku, function(k, v){
                            tmpSku.push(parseInt(k));
                        });
                    }
                } else if( typeof self._itemPricingJSONCache[self._productId[index]].pricing[attrId][attrValue] !== "undefined"){
                    tmpSku = self._itemPricingJSONCache[self._productId[index]].pricing[attrId][attrValue].sku;
                }

                if(attrIndex < 0) {
                    // add the possible skus of the selected attribute into _possibleProducts if it is not already there
                    self._possibleProducts[index].push({
                        "attrId": attrId,
                        "sku": tmpSku
                    });
                } else {
                    // if the attribute has an entry already, update the skus
                    self._possibleProducts[index][attrIndex].sku = tmpSku;
                }
            }
        }
    };


	return that;
	// START close Require.JS wrapper
	}
);
// END close Require.JS wrapper
